import React from 'react';
import useLandlordData from '../hooks/useLandlordData';
import TenantCard    from '../components/TenantCard';

export default function Tenants() {
  const { tenants, loading, error } = useLandlordData();
  if (loading) return <p>Loading tenants…</p>;
  if (error)   return <p>Error loading tenants.</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>All Tenants</h2>
      <div style={styles.list}>
        {tenants.map(t => (
          <TenantCard key={t.id} count={1} />
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '2rem', fontFamily: 'Arial, sans-serif' },
  heading:   { fontSize: '1.5rem', marginBottom: '1rem' },
  list:      {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill,minmax(250px,1fr))',
    gap: '1rem'
  }
};